import React, {useState} from 'react'
import {Selected} from './context/context'
import { useLocation } from 'react-router-dom'
import Nav from './components/Nav/Nav'
import StampBg from './components/Backgrounds/StampBg'
import DynamicBg from './components/Backgrounds/DynamicBg'
import Home from './components/Home/Home'

function App() {

  const location = useLocation()

  const [selected, setSelected] = useState({
    tecnica: "bordado",
    producto: "Buzo Algodon Canguro",
    precioUnidad: 0,
    imagen: "https://firebasestorage.googleapis.com/v0/b/seba-app.appspot.com/o/prendasImages%2Fbuzo-algodon-escote.jpg?alt=media&token=8d29d227-507c-4a93-a1ef-04654e1a439e",
    color: "Sin seleccionar",
    coloresDisponibles: "",
    cantidad: "Sin seleccionar",
    size: "Sin seleccionar",
    ubicacion: "Sin seleccionar",
    total: 0
  })

  return (
    <Selected.Provider value={[selected, setSelected]}>
      <StampBg location={location} />
      <DynamicBg location={location} />
      <Nav location={location} />
      <Home location={location} />
    </Selected.Provider>
  );
}

export default App;
